export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16 bg-primary-500 rounded-2xl overflow-hidden">
            <div className="flex-1 px-6 md:px-10 py-8 md:py-12">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/20 text-white text-xs font-medium mb-4">
                <i className="ri-smartphone-line"></i>
                <span>移动端专属</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">皮皮漫画移动端</h2>
              <p className="text-sm md:text-base text-white/85 leading-relaxed mb-6 max-w-lg">
                下载皮皮漫画APP，享受更流畅的移动阅读体验。离线下载、夜间模式、阅读进度云同步，
                让你随时随地畅享皮皮漫画韩漫、日漫、国漫的全部精彩内容。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-primary-600 rounded-full text-sm font-medium hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line"></i>
                  iOS 下载
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/20 text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line"></i>
                  Android 下载
                </a>
              </div>
            </div>
            <div className="hidden lg:block flex-1">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20manga%20reading%20app%20interface%20with%20Korean%20webtoon%20style%2C%20clean%20modern%20UI%2C%20warm%20orange%20accent%20highlights%2C%20minimal%20device%20mockup%2C%20friendly%20illustration%20style%2C%20soft%20background&width=600&height=500&seq=app-section-01&orientation=landscape"
                alt="皮皮漫画移动端APP展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}